module.exports = __webpack_public_path__ + "assets/mailchimp-for-wordpress.8a2aeddd.svg";